import { FC, ReactElement } from 'react'
import { Social } from './partials/social'
import { WrapLogin } from './partials/wrap'
import { IconEmail } from './icons'

export const ResendLink: FC = (): ReactElement => (
  <WrapLogin>
    <form
      id="resetForm"
      name="resetForm"
      action="/"
      className="registration__form"
    >
      <h1 className="registration__title">Resend Activation Email</h1>

      <div className="registration__right__body">
        <div className="registration__item__list">
          <div className="registration__item">
            <div className="registration__input__title">
              Enter Your Registered Email
            </div>
            <div className="contact__wrapper">
              <IconEmail />
              <input
                type="email"
                className="resitration__input form-control contact__input payment__input payment__input--special"
                name="emailRegistered"
                id="emailRegistered"
                placeholder="Registered email"
                required
              />
            </div>
            <label
              id="emailRegistered-error"
              htmlFor="emailRegistered"
              className="error registration__input__message"
            />
          </div>
        </div>
      </div>
      <Social />
    </form>
  </WrapLogin>
)
